import React, { useContext, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { deleteRegion, getAllDetailsOfRegion } from '../../redux/slices/regionSlice'
import { deleteCity } from '../../redux/slices/citySlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import DeletePopup from '../../component/deletePopup'
import DeleteIcon from '../../assets/img/svg/delete-icon.svg'
import { Spinner } from 'react-bootstrap'
import RegionsDeleteModal from '../../component/modal/regionsDeleteModal'
import { getUserRole, hasAccess } from '../../helper/function'

const CardView = ({
  listData,
  keyName,
  keyName2 = '',
  keyName3 = '',
  setRegionID,
  setIsRefresh,
  isLoading = false,
  onHandleSubmit,
  setDeleteRegionId
}) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const [clickedID, setClickedID] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isRegionModalOpen, setIsRegionModalOpen] = useState(false)
  const [deleteId, setDeleteID] = useState(null)
  // Toggle delete modal
  const toggleDeleteModal = useCallback(() => {
    setIsDeleteModalOpen((prev) => !prev)
  }, [])

  const toggleRegionModal = useCallback(() => {
    setIsRegionModalOpen((prev) => !prev)
  }, [])

  // Handle delete action for region/city
  const handleDelete = useCallback(() => {
    setIsRefresh(false)
    if (!deleteId) return

    const deleteAction = keyName === 'region' ? deleteRegion(deleteId) : deleteCity(deleteId)

    dispatch(deleteAction).then(({ payload, error }) => {
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Deleted successfully!')
        setIsRefresh(true)
      } else {
        toggleDeleteModal()
        if (keyName === 'region') {
          getRegionDetails(deleteId)
        }
        errorToast(payload?.data?.status_message || error?.message)
      }
      toggleDeleteModal()
      changeLoader(false)
    })
  }, [deleteId, keyName, dispatch, changeLoader, setIsRefresh, toggleDeleteModal])

  // Handle card click to set the region ID
  const handleCardClick = (id) => {
    if (keyName === 'region') {
      setRegionID(id)
      setClickedID(id)
    }
  }

  const getRegionDetails = (id) => {
    toggleDeleteModal()
    changeLoader(true)
    dispatch(getAllDetailsOfRegion(id))
      .then((res) => {
        changeLoader(false)
        if (!res?.error) {
          setTimeout(() => {
            toggleRegionModal()
          }, 1000)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  // Handle delete icon click
  const handleDeleteClick = (id) => {
    setDeleteID(id)
    setDeleteRegionId && setDeleteRegionId(id)
    toggleDeleteModal()
  }

  const onhandleSubmitCard = () => {
    onHandleSubmit()
    toggleRegionModal()
  }

  return (
    <>
      <div className="common_card_div mb-4">
        <div className="regions_scroll_div">
          <div className="row">
            {isLoading ? (
              <div className="custom-spinner-main">
                <Spinner className="custom-spinner" animation="border" size="sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : listData?.length > 0 ? (
              listData?.map((data, index) => {
                const id = keyName === 'region' ? data?.region_id : data?.city_id
                const label = `${data[keyName]} ${keyName2 ? data[keyName2] : ''}`

                return (
                  <div className="col-md-6" key={id || index}>
                    <div className={`input_icon_box ${keyName === 'region' && clickedID !== data?.region_id ? 'disabled_filed' : ''}`}>
                      <div className="form-group mb-0 w-100" style={{ cursor: 'pointer' }} onClick={() => handleCardClick(data?.region_id)}>
                        <div className="input_text_box">
                          {label} {keyName3 ? `(${data[keyName3]})` : ''}
                        </div>
                      </div>
                      {((keyName === 'region' && hasAccess('newRegionButton', getUserRole())) || keyName === 'city' && hasAccess('newCityButton', getUserRole())) && (
                        <div className="icon_box_div delete_icon" onClick={() => handleDeleteClick(id)}>
                          <img src={DeleteIcon} alt="delete" width={17} />
                        </div>
                      )}
                    </div>
                  </div>
                )
              })
            ) : (
              <p style={{ textAlign: 'center' }}>No Data Found</p>
            )}
          </div>
        </div>
      </div>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={toggleDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={toggleDeleteModal}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={handleDelete}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}

      {keyName === 'region' && isRegionModalOpen && (
        <RegionsDeleteModal isOpen={isRegionModalOpen} toggleModal={toggleRegionModal} onHandleSubmit={onhandleSubmitCard} />
      )}
    </>
  )
}

export default React.memo(CardView)
